import { createContext, useContext, useEffect, useState } from 'react';
import React from 'react'
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../firebase';

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {

  const [user, setUser] = useState({});
  const [loadingUser, setLoadingUser] = useState(true);

  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
  };

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
  }

  const logout = () => {
    return signOut(auth)
  }

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      // console.log(currentUser);
      setUser(currentUser);
      setLoadingUser(false);
    });
    return () => {
      unsubscribe();
    };
  }, [user]);

  return (
    <UserContext.Provider value={{ createUser, user, logout, signIn, loadingUser }}>
      {children}
    </UserContext.Provider>

  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
